import axios from 'axios'
import store from '@/store'
import router from '@/router'

const HOST = process.env.VUE_APP_HOST
// const API_TOKEN = process.env.VUE_APP_API_TOKEN

const API_URL = `${HOST}/v1`

// axios.defaults.headers.common['Content-Type'] = 'application/json'
// axios.defaults.headers.common['API-Token'] = API_TOKEN

function handleResponse (response, resolve, reject) {
  if (response.unauthorized) {
    reject(response.error)
  } else if (response.status === 'error') {
    reject(response.error)
  } else {
    resolve(response)
  }
}

export default {
  API_URL: `${HOST}/v1`,
  newRequest (method, url, payload) {
    var fullUrl = API_URL + url
    var headers = {
      'Content-Type': 'application/json',
      'API-Token': window.localStorage.getItem('token')
    }
    var token = window.localStorage.getItem('jwt')
    if (token) {
      headers.Authorization = 'JWT ' + token
    }
    return new Promise(function (resolve, reject) {
      axios({
        method: method,
        url: fullUrl,
        data: payload,
        headers: headers
      }).then((resp) => {
        console.log(resp.data)
        console.log(resp.status)
        console.log(resp.statusText)
        console.log(resp.headers)
        console.log(resp.config)
        handleResponse(resp.data, resolve, reject)
      }).catch((error) => {
        console.log(error)
        var errorReponse = { code: 0, title: 'Unkown API error', message: 'Unkown API error' }
        if (error.response) {
          if (error.response.status === 401) {
            // Logout unauthorized tokens
            store.dispatch('logout')
            router.push('/login')
          } else if (error.response.data && error.response.data.status === 'error') {
            errorReponse = error.response.data.error
          }
        } else {
          errorReponse.title = error.message
          errorReponse.message = error.message
        }
        reject(errorReponse)
      })
    })
  },
  newUploadRequest (formData, uuid, didSetCancelToken) {
    var fullUrl = `${HOST}/upload?X-Progress-ID=${uuid}`
    // var token = window.localStorage.getItem('jwt')
    // if (token) {
    //   axios.defaults.headers.common['Authorization'] = 'JWT ' + token
    // }
    const CancelToken = axios.CancelToken

    return new Promise(function (resolve, reject) {
      axios({
        method: 'post',
        url: fullUrl,
        data: formData,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        },
        cancelToken: new CancelToken(function executor (c) {
          didSetCancelToken(c)
        })
      }).then((resp) => {
        console.log(resp)
        handleResponse(resp.data, resolve, reject)
      }).catch((error) => {
        console.log(error)
        var errorReponse = { code: 0, title: 'Unkown API error', message: 'Unkown API error' }
        if (error.response) {
          if (error.response.status === 401) {
            // Logout unauthorized tokens
            store.dispatch('logout')
            router.push('/login')
          } else if (error.response.data && error.response.data.status === 'error') {
            errorReponse = error.response.data.error
          }
        } else {
          errorReponse.title = error.message
          errorReponse.message = error.message
        }
        reject(errorReponse)
      })
    })
  }
}
